import React, { useMemo } from "react";
import { H1, H4 } from "../Typography";
import { PrimaryButton } from "../PrimaryButton";
import FourOFour from "../images/FourOFour";
import Container from "@material-ui/core/Container";
import { useMuiContainerStyles } from "../../hooks";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { styled } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

export interface NotFoundPageProps {
  isPageLoading?: boolean | null;
  buttonText?: string;
  headerStyle?: React.CSSProperties;
  subHeaderStyle?: React.CSSProperties;
  customFourOFourMarginTop?: number;
  customButtonMarginTop?: number;
  customHeaderMarginTop?: number;
  customSubHeaderMarginTop?: number;
}

export default function NotFoundPage(props: NotFoundPageProps) {
  const containerClasses = useMuiContainerStyles();
  const {
    isPageLoading,
    headerStyle,
    subHeaderStyle,
    customFourOFourMarginTop,
    customButtonMarginTop,
    customSubHeaderMarginTop,
    customHeaderMarginTop,
  } = props;

  const Page404 = useMemo(
    () => (
      <Container classes={containerClasses} maxWidth="lg" data-testid="dashboard-page">
        <CenteredContainer style={{ marginTop: customFourOFourMarginTop || 60 }}>
          <FourOFour />
        </CenteredContainer>
        <CenteredContainer style={{ marginTop: customHeaderMarginTop || 50, textAlign: "center" }}>
          <Title style={headerStyle}>Sorry, this page is missing.</Title>
        </CenteredContainer>
        <CenteredContainer style={{ marginTop: customSubHeaderMarginTop || 12, textAlign: "center" }}>
          <H4 color="textSecondary" style={subHeaderStyle}>
            Looks like we sent you down the wrong path. Let’s get you back!
          </H4>
        </CenteredContainer>
        <CenteredContainer style={{ marginTop: customButtonMarginTop || 114 }}>
          <PrimaryButton color="primary" onClick={() => window.location.assign("/")}>
            Back to dashboard
          </PrimaryButton>
        </CenteredContainer>
      </Container>
    ),
    [
      containerClasses,
      customFourOFourMarginTop,
      customHeaderMarginTop,
      headerStyle,
      customSubHeaderMarginTop,
      subHeaderStyle,
      customButtonMarginTop,
    ]
  );

  const LoadingPage = useMemo(() => <CircularProgress />, []);

  return isPageLoading ? LoadingPage : Page404;
}

// eslint-disable-next-line cohere-react/no-mui-styled-import
const Title = styled(H1)({
  fontWeight: 600,
  fontSize: 50,
  lineHeight: "80px",
});

// eslint-disable-next-line cohere-react/no-mui-styled-import
const CenteredContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
});
